"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSettingsOperation = void 0;
exports.setSettingsOperation = {
    method: 'POST',
    name: 'setSettings',
    id: 'SetSettings',
    groupName: 'project',
    urlPathPattern: '/settings',
    bodyParamNames: ['region'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function getRequestBody(request) {
    return {
        region: request.region,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        region: request.region,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        region: jsonRequest.region,
    };
}
//# sourceMappingURL=setSettingsOperation.js.map